var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 2,
    viewBox: "0 0 11 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0117 1.48828H0.988281C0.858781 1.48828 0.734585 1.43684 0.643014 1.34527C0.551444 1.2537 0.5 1.1295 0.5 1C0.5 0.8705 0.551444 0.746303 0.643014 0.654733C0.734585 0.563162 0.858781 0.511719 0.988281 0.511719H10.0117C10.1412 0.511719 10.2654 0.563162 10.357 0.654733C10.4486 0.746303 10.5 0.8705 10.5 1C10.5 1.1295 10.4486 1.2537 10.357 1.34527C10.2654 1.43684 10.1412 1.48828 10.0117 1.48828Z",
    fill: "#E92127"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.64150d6e9281e5b2022ea1d197ac88e1.svg";
export { ForwardRef as ReactComponent };